import { AssetQualityLevel, IResourcesGroupConfig } from "@nolimitcity/slot-game/bin/asset/Asset";
import { BitmapFontAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import { SpineAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import { TextureAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import { FontAsset } from "@nolimitcity/slot-launcher/bin/loader/font/FontCache";
import { FontStyle, FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

import { ApocalypseFontsNames, ApocalypseSpineNames } from "./ApocalypseAssetsNames";

export class ApocalypseTTF {
    public static FAMILY: string = `ApocalypseTTF`;
    public static BASE_URL: string = `/resources/fonts/`;
    public static NORMAL: FontAsset = {
        family: ApocalypseTTF.FAMILY,
        weight: FontWeight.REGULAR,
        style: FontStyle.NORMAL,
        url: ApocalypseTTF.BASE_URL + `ApocalypseTTF.ttf`,
    };
}

export class ApocalypseAssetsLoader {
    // eslint-disable-next-line no-undef
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: `fonts`,
                assets: [
                    new BitmapFontAsset(
                        ApocalypseFontsNames.APOCALYPSE_BLUE,
                        `fonts/bitmapfonts/ApocalypseFontBlue.fnt`
                    ),
                    new BitmapFontAsset(
                        ApocalypseFontsNames.APOCALYPSE_RED,
                        `fonts/bitmapfonts/ApocalypseFontRed.fnt`
                    ),
                    new BitmapFontAsset(
                        ApocalypseFontsNames.APOCALYPSE_GREEN,
                        `fonts/bitmapfonts/ApocalypseFontGreen.fnt`
                    ),
                    new BitmapFontAsset(
                        ApocalypseFontsNames.APOCALYPSE_WHITE,
                        `fonts/bitmapfonts/ApocalypseFontWhite.fnt`
                    ),
                ],
            },
            {
                name: `backgrounds`,
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset(`backgrounds0`, `sheets/backgrounds/backgrounds0.json`),
                    new TextureAsset(`backgrounds1`, `sheets/backgrounds/backgrounds1.json`),
                    new TextureAsset(`backgrounds2`, `sheets/backgrounds/backgrounds2.json`),
                    new TextureAsset(`backgrounds3`, `sheets/backgrounds/backgrounds3.json`),
                    // new TextureAsset(`backgrounds4`, `sheets/backgrounds/backgrounds4.json`),
                ],
            },
            {
                name: `bigwins`,
                assets: [
                    new TextureAsset(`bigWin0`, `sheets/bigwins/bigwins0.json`),
                    new TextureAsset(`bigWin1`, `sheets/bigwins/bigwins1.json`),
                    new TextureAsset(`bigWin2`, `sheets/bigwins/bigwins2.json`),
                    new TextureAsset(`bigWin3`, `sheets/bigwins/bigwins3.json`),
                    new TextureAsset(`bigWin4`, `sheets/bigwins/bigwins4.json`),
                    new TextureAsset(`bigWin5`, `sheets/bigwins/bigwins5.json`),
                    new TextureAsset(`bigWin6`, `sheets/bigwins/bigwins6.json`),
                    new TextureAsset(`bigWin7`, `sheets/bigwins/bigwins7.json`),
                    new TextureAsset(`bigWin8`, `sheets/bigwins/bigwins8.json`),
                    new TextureAsset(`bigWin9`, `sheets/bigwins/bigwins9.json`),
                    new TextureAsset(`bigWin10`, `sheets/bigwins/bigwins10.json`),
                    new TextureAsset(`bigWin11`, `sheets/bigwins/bigwins11.json`),
                ],
            },
            {
                name: `freespins`,
                assets: [
                    new TextureAsset(`freespins0`, `sheets/freespins/freespins0.json`),
                    new TextureAsset(`freespins1`, `sheets/freespins/freespins1.json`),
                    new TextureAsset(`freespins2`, `sheets/freespins/freespins2.json`),
                    // new TextureAsset(`freespins3`, `sheets/freespins/freespins3.json`),
                ],
                animations: {},
            },
            {
                name: `introOutro`,
                assets: [
                    new TextureAsset(`introOutro0`, `sheets/introOutro/introOutro0.json`),
                    new TextureAsset(`introOutro1`, `sheets/introOutro/introOutro1.json`),
                    new TextureAsset(`introOutro2`, `sheets/introOutro/introOutro2.json`),
                ],
                animations: {},
            },
            {
                name: `main`,
                assets: [
                    new TextureAsset(`main0`, `sheets/main/main0.json`),
                    new TextureAsset(`main1`, `sheets/main/main1.json`),
                    new TextureAsset(`main2`, `sheets/main/main2.json`),
                    // new TextureAsset(`main3`, `sheets/main/main3.json`),
                    // new TextureAsset(`main4`, `sheets/main/main4.json`),
                    // new TextureAsset(`main5`, `sheets/main/main5.json`),
                ],
            },
            {
                name: `mainJpeg`,
                assets: [
                    new TextureAsset(`mainJpeg0`, `sheets/mainJpeg/mainJpeg0.json`),
                    new TextureAsset(`mainJpeg1`, `sheets/mainJpeg/mainJpeg1.json`),
                    new TextureAsset(`mainJpeg2`, `sheets/mainJpeg/mainJpeg2.json`),
                    new TextureAsset(`mainJpeg3`, `sheets/mainJpeg/mainJpeg3.json`),
                    new TextureAsset(`mainJpeg4`, `sheets/mainJpeg/mainJpeg4.json`),
                    new TextureAsset(`mainJpeg5`, `sheets/mainJpeg/mainJpeg5.json`),
                ],
            },
            {
                name: `reels`,
                assets: [
                    new TextureAsset(`reels0`, `sheets/reels/reels0.json`),
                    // new TextureAsset(`reels1`, `sheets/reels/reels1.json`),
                    // new TextureAsset(`reels2`, `sheets/reels/reels2.json`),
                ],
                animations: {},
            },
            {
                name: `symbols`,
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset(`symbols0`, `sheets/symbols/symbols0.json`),
                    new TextureAsset(`symbols1`, `sheets/symbols/symbols1.json`),
                    new TextureAsset(`symbols2`, `sheets/symbols/symbols2.json`),
                    // new TextureAsset(`symbols3`, `sheets/symbols/symbols3.json`),
                    // new TextureAsset(`symbols4`, `sheets/symbols/symbols4.json`),
                ],
                animations: {},
            },
            {
                name: `spine`,
                assets: [
                    new SpineAsset(
                        ApocalypseSpineNames.ANTICIPATION,
                        ApocalypseSpineNames.ANTICIPATION
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.HIGH_LOCKER,
                        ApocalypseSpineNames.HIGH_LOCKER
                    ),

                    new SpineAsset(ApocalypseSpineNames.M1, ApocalypseSpineNames.M1),

                    new SpineAsset(ApocalypseSpineNames.M2, ApocalypseSpineNames.M2),
                    new SpineAsset(ApocalypseSpineNames.M3, ApocalypseSpineNames.M3),
                    new SpineAsset(ApocalypseSpineNames.M4, ApocalypseSpineNames.M4),

                    new SpineAsset(ApocalypseSpineNames.M5, ApocalypseSpineNames.M5),
                    new SpineAsset(ApocalypseSpineNames.CROW, ApocalypseSpineNames.CROW),

                    new SpineAsset(ApocalypseSpineNames.L1, ApocalypseSpineNames.L1),
                    new SpineAsset(ApocalypseSpineNames.L2, ApocalypseSpineNames.L2),
                    new SpineAsset(ApocalypseSpineNames.L3, ApocalypseSpineNames.L3),
                    new SpineAsset(ApocalypseSpineNames.L4, ApocalypseSpineNames.L4),
                    new SpineAsset(ApocalypseSpineNames.L5, ApocalypseSpineNames.L5),

                    new SpineAsset(ApocalypseSpineNames.SCATTER, ApocalypseSpineNames.SCATTER),
                    new SpineAsset(ApocalypseSpineNames.XNUDGE, ApocalypseSpineNames.XNUDGE),
                    new SpineAsset(ApocalypseSpineNames.WILD, ApocalypseSpineNames.WILD),
                    new SpineAsset(
                        ApocalypseSpineNames.SUPER_XNUDGE,
                        ApocalypseSpineNames.SUPER_XNUDGE
                    ),
                    new SpineAsset(ApocalypseSpineNames.BLANK, ApocalypseSpineNames.BLANK),
                    new SpineAsset(
                        ApocalypseSpineNames.REEL_BLOCKER_TOP,
                        ApocalypseSpineNames.REEL_BLOCKER_TOP
                    ),

                    new SpineAsset(ApocalypseSpineNames.BIG_WIN_1, ApocalypseSpineNames.BIG_WIN_1),
                    new SpineAsset(ApocalypseSpineNames.BIG_WIN_2, ApocalypseSpineNames.BIG_WIN_2),
                    new SpineAsset(ApocalypseSpineNames.BIG_WIN_3, ApocalypseSpineNames.BIG_WIN_3),
                    new SpineAsset(ApocalypseSpineNames.BIG_WIN_4, ApocalypseSpineNames.BIG_WIN_4),
                    new SpineAsset(ApocalypseSpineNames.BIG_WIN_5, ApocalypseSpineNames.BIG_WIN_5),
                    new SpineAsset(
                        ApocalypseSpineNames.MAX_CAP_WIN,
                        ApocalypseSpineNames.MAX_CAP_WIN
                    ),

                    new SpineAsset(ApocalypseSpineNames.BG_SMOKE, ApocalypseSpineNames.BG_SMOKE),
                    new SpineAsset(
                        ApocalypseSpineNames.PERSISTENT_GLITCH,
                        ApocalypseSpineNames.PERSISTENT_GLITCH
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.TV_FLICKER,
                        ApocalypseSpineNames.TV_FLICKER
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.FS_INTRO_OUTRO_DOORS,
                        ApocalypseSpineNames.FS_INTRO_OUTRO_DOORS
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.BG_FIRE_SPINE,
                        ApocalypseSpineNames.BG_FIRE_SPINE
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.BG_LOST_SIGNAL,
                        ApocalypseSpineNames.BG_LOST_SIGNAL
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.BG_RED_SCREEN,
                        ApocalypseSpineNames.BG_RED_SCREEN
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.BG_FRONT_BILLBOARD,
                        ApocalypseSpineNames.BG_FRONT_BILLBOARD
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.BG_GREEN_SCREEN,
                        ApocalypseSpineNames.BG_GREEN_SCREEN
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.HAHA_BILLBOARD,
                        ApocalypseSpineNames.HAHA_BILLBOARD
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.END_BILLBOARD,
                        ApocalypseSpineNames.END_BILLBOARD
                    ),
                    new SpineAsset(
                        ApocalypseSpineNames.GHOST_SYMBOL_ANTICIPATION,
                        ApocalypseSpineNames.GHOST_SYMBOL_ANTICIPATION
                    ),
                ],
            },
        ],
    };
}
